<script setup lang="ts">
import { ref } from 'vue'
import { vOnClickOutside } from '@vueuse/components'

import OpacityBackdrop from '@/shared/components/backdrop/OpacityBackdrop.vue'
import ScaleTransition from '@/shared/components/transitions/ScaleTransition.vue'

interface Props {
  title: string
}

defineProps<Props>()
defineOptions({ inheritAttrs: false })
const open = defineModel<boolean>('open', { required: true })

const isOutside = ref<boolean>(false)

const onClose = (): void => {
  isOutside.value = !isOutside.value
}
</script>

<template>
  <OpacityBackdrop :active="open" class="z-40" />
  <ScaleTransition>
    <div
      v-if="open"
      class="fixed z-40 flex top-0 left-0 min-h-screen w-full items-center justify-center"
    >
      <div
        class="w-full max-w-md bg-white shadow-lg"
        :class="{ 'animate-shake': isOutside }"
        v-on-click-outside="onClose"
        v-bind="$attrs"
      >
        <div class="font-medium text-center text-lg text-gray-700 p-4">{{ title }}</div>
        <slot></slot>
      </div>
    </div>
  </ScaleTransition>
</template>
